import logo from 'assets/images/square_logo.svg';

export const JOBS = [
  {
    title: 'Product Manager',
    label: 'Unissu Talent',
    headline:
      'Our client is seeking to appoint a Product manager to their senior management team. They operate within tenant referencing and have a suite of valuation tools they are releasing.',
    url:
      'https://jobs.unissu.com/jobs/product-manager-in-london-greater-london-england/',
    imageData: { image: logo, width: 65, height: 65 }
  },
  {
    title: 'Head of Business Development',
    label: 'Unissu Talent',
    headline:
      'Insurami enhances the risk management functions for commercial real estate landlords and in turn provides an affordable alternative to tenants for their security deposit.',
    url:
      'https://jobs.unissu.com/jobs/head-of-business-development-in-london-greater-london-england/',
    imageData: { image: logo, width: 65, height: 65 }
  },
  {
    title: 'Community Engagement Manager',
    label: 'Unissu Talent',
    headline:
      'Unissu Talent are working with an innovative PropTech start-up seeking a passionate community engagement professional who wants to Harness tech to make a positive impact.',
    url:
      'https://jobs.unissu.com/jobs/community-engagement-manager-in-london-greater-london-england/',
    imageData: { image: logo, width: 65, height: 65 }
  },
  {
    title: 'Sales Operations Manager',
    label: 'Unissu Talent',
    headline:
      'Unissu Talent are working with one of the fastest growing start-ups in the UK. Their mission is to improve people’s lives by making property management more straightforward.',
    url:
      'https://jobs.unissu.com/jobs/sales-operations-manager-in-london-greater-london-england/',
    imageData: { image: logo, width: 65, height: 65 }
  }
];
